<template>
  <el-table-column
    prop="cash_net"
    label="Nettó értékesítés"
    align="right"
    width="150"
  >
    <template slot-scope="scope">
      {{ scope.row.cash_net | currency }}
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'unit_purchase_price',
};
</script>
